import { useCallback } from 'react';
import { toast } from 'react-toastify';

export const useNotification = () => {
  const showSuccessNotification = useCallback((message) => {
    toast.success(message);
  }, []);

  const showErrorNotification = useCallback((message) => {
    toast.error(message);
  }, []);

  return {
    showSuccessNotification,
    showErrorNotification,
  };
};
